module.exports = __webpack_public_path__ + "img/index_icon.fd28b81f.png";